import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-steps-third.scss";
import {IWebsiteBlackStepsThird} from "./types/IWebsiteBlackStepsThird";

export class WebsiteBlackStepsThirdComponent extends Component {
    constructor(steps: IWebsiteBlackStepsThird[]) {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackStepsThird}">
                ${steps.map(step => `
                    <div class="${s.entry}">
                        <div class="${s.names}">
                            <div class="${s.title}">
                                <div class="${s.step}">
                                    <div class="${s.stepShadow}"></div>
                                    <div class="${s.text}">${step.step}</div>
                                </div>
                                <h4>${step.title}</h4>
                            </div>
                            <p class="${s.description}">
                                ${step.description}
                            </p>
                        </div>
                        ${step.image ? `<div class="${s.imageContainer}"><img class="${s.image}" src="${step.image}" alt="${step.imageAlt}"/></div>`:``}
                        <div class="${s.shadow}"></div>
                    </div>
                `).join(`
                    <div class="${s.separator}"></div>
                `)}
            </div>
        `;
    }

    //<div class="${s.imageContainer}"><img class="${s.image}" src="${entry.image}" alt="presentation"/></div>
}